export default __webpack_public_path__ + "static/media/profileActive.144524fe.svg";